import { GameUIMessageType } from 'game-ui-types'

export const sendPopupOpened = () => window.postMessage({ type: GameUIMessageType.POPUP_OPENED })
export const sendPopupClosed = () => window.postMessage({ type: GameUIMessageType.POPUP_CLOSED })
